var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentingSlideIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.26562,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.26562,
    width: 41.3828,
    height: 41.3828,
    rx: 5.55469,
    stroke: "#EFF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21381_17433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5577 13.4424H11.826C11.3558 13.4424 10.9746 13.8236 10.9746 14.2938V27.0654C10.9746 27.5357 11.3558 27.9169 11.826 27.9169H30.5577C31.028 27.9169 31.4092 27.5357 31.4092 27.0654V14.2938C31.4092 13.8236 31.028 13.4424 30.5577 13.4424Z",
    fill: "#E4E3F6",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5977 27.917L28.0034 32.1742",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7847 27.917L14.3789 32.1742",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7852 21.1055V23.6598",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1914 19.4023V23.6595",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5977 17.7002V23.6603",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1914 13.443V10.8887",
    stroke: "#42296E",
    strokeWidth: 1.3623,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21381_17433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2461,
    height: 27.2461,
    fill: "white",
    transform: "translate(7.56836 8.33398)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentingSlideIcon);
export default __webpack_public_path__ + "static/media/presenting_slide_icon.137f993b74c9f43de13069d7fcc30538.svg";
export { ForwardRef as ReactComponent };